import { useEventPhotos } from 'api/assetManifest';
import { CharityEvent } from 'api/charityEventAPI';
import { PhotoGallery } from 'components/shared/PhotoGallery';

interface EventImageGalleryProps {
    event?: Partial<CharityEvent>;
}

/**
 * An event's photographs, addressed by event **id**.
 *
 * It used to be keyed by `eventTitle` against a dictionary compiled into the
 * bundle, which coupled the database to frontend source: renaming an event
 * silently deleted its gallery. See `api/assetManifest` for the rest of that
 * story.
 */
export const EventImageGallery = ({ event = undefined }: EventImageGalleryProps) => (
    <PhotoGallery photos={useEventPhotos(event?.eventId)} />
);
